import { render, staticRenderFns } from "./picklist.vue?vue&type=template&id=8738d8a8&"
import script from "./picklist.vue?vue&type=script&lang=js&"
export * from "./picklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports